import { predictionAdminApis } from '@gleamer/apis';
import { PredictionAdmin } from '@gleamer/types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuthorization } from './useImports';

const {
  createPredictionProduct,
  deletePredictionProduct,
  fetchPredictionProducts,
  updatePredictionProduct,
} = predictionAdminApis;

export const PREDICTION_PRODUCTS_KEY = 'prediction-products';

/** The products, by name. */
export function usePredictionProducts() {
  const auth = useAuthorization();
  return useQuery({
    queryKey: [PREDICTION_PRODUCTS_KEY],
    queryFn: () => fetchPredictionProducts(auth),
  });
}

/** Creates, renames or deletes a product, then reads the list again. */
export function usePredictionProductCommands() {
  const auth = useAuthorization();
  const queryClient = useQueryClient();
  const refresh = () => queryClient.invalidateQueries({ queryKey: [PREDICTION_PRODUCTS_KEY] });
  return {
    create: useMutation({
      mutationFn: (product: PredictionAdmin.NewPredictionProduct) =>
        createPredictionProduct(auth, product),
      onSuccess: refresh,
    }),
    update: useMutation({
      mutationFn: ({
        id,
        change,
      }: {
        id: number;
        change: PredictionAdmin.PredictionProductChange;
      }) => updatePredictionProduct(auth, id, change),
      onSuccess: refresh,
    }),
    remove: useMutation({
      mutationFn: (id: number) => deletePredictionProduct(auth, id),
      onSuccess: refresh,
    }),
  };
}
